import { useState, useEffect } from 'react';

import { SAMPLE_ID } from '../constants';

import { sampleFifa } from '../pages/VideoBuilder/components/sampleProjectData';

const useSampleProjectData = (eventId?: string) => {
  const isSample = eventId === SAMPLE_ID.FIFA;

  const [sampleProjectData, setSampleProjectData] = useState(
    JSON.parse(localStorage.getItem('sampleProjectData') ?? '{}'),
  );

  useEffect(() => {
    const handler = () =>
      setSampleProjectData(
        JSON.parse(localStorage.getItem('sampleProjectData') ?? '{}'),
      );

    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  const updateSampleProjectData = (data: {}) => {
    localStorage.setItem('sampleProjectData', JSON.stringify(data));
    window.dispatchEvent(new Event('storage'));
  };

  const resetSampleProjectData = () => {
    localStorage.setItem('sampleProjectData', JSON.stringify(sampleFifa));
    window.dispatchEvent(new Event('storage'));
  };

  return {
    isSample,
    sampleProjectData,
    updateSampleProjectData,
    resetSampleProjectData,
  };
};

export default useSampleProjectData;
